import type { SVGProps } from 'react'
const SvgSyTechSolidStackdriver = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path fillOpacity={0.24} d="m11.19 11.35 4.56-7.84h-9l-4.5 7.84z" />
		<path d="m2.25 12.65 4.49 7.84h8.99l-4.48-7.84z" />
		<path fillOpacity={0.4} d="m21.75 12-4.5-7.87L12.74 12l4.51 7.87z" />
	</svg>
)
export default SvgSyTechSolidStackdriver
